import { useLagoon } from '../useLagoon';
import { getLagoonConfigValue } from '../../utils/providerSearch.utils';
import { useSmartChoice } from '../useSmartChoice';

export const useMinProviderCount = (): string => {
  const allConfigs = useLagoon('config');
   const isSmartChoice = useSmartChoice();
    const minProviderCountOthers = getLagoonConfigValue(
      allConfigs,
      'MIN_PROVIDER_COUNT_OTHER'
    );
    const providerCountRecommendation = getLagoonConfigValue(
      allConfigs,
      'MIN_PROVIDER_COUNT_RECOMMENDATION'
    );
  const minimumProvidersReturn = isSmartChoice
    ? providerCountRecommendation
    : minProviderCountOthers

  return minimumProvidersReturn?.length > 0 ? minimumProvidersReturn : '';
};
